<template>
  <v-layout row wrap data-qa="casadetails-layout-vr87ei">
    <Loader v-if="loaderEnabled"/>
    <v-layout wrap class="ml-2" data-qa="casadetails-layout-x665q">
      <v-flex
        cols="12"
        :style="{ background: dashboardGradient }"
        class="pb-2"
        data-qa="casadetails-flex-kz0oxk">
        <v-container :class="{ 'pa-6 pl-12': !$vuetify.breakpoint.smAndDown }" data-qa="casadetails-container-2wqd5">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="casadetails-flex-g61zmu">
            <v-row no-gutters data-qa="casadetails-row-p6iptp">
              <v-layout row wrap class="pb-2" data-qa="casadetails-layout-3ji7p">
                <div class="d-flex align-center pb-2" data-qa="casadetails-div-dqqzh">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon(defaultAccountType)"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <v-layout column data-qa="casadetails-layout-kxonr">
                    <font
                      class="display-1 font-weight-thin white--text pt-4 pl-2"
                      >{{ getAccountTypeLabel(defaultAccountType) }}</font
                    >
                    <font
                      class="text-h5 font-weight-thin white--text pl-2" v-if="showProductDescription"
                      >{{ productDescription }}</font
                    >
                  </v-layout>
                </div>

                <v-tooltip
                  v-if="isInstantCashIsaAccount || isFixedRateCashIsaAccount"
                  v-model="showTransferOut"
                  :right="$vuetify.breakpoint.xl"
                  :top="$vuetify.breakpoint.lgAndDown"
                  data-qa="casadetails-tooltip-chj9f7">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="enableTransferOutInfo"
                      icon
                      v-bind="on"
                      @click="showTransferOut = !showTransferOut"
                      class="mt-5 mx-2"
                      data-qa="casadetails-btn-gg52m">
                      <v-icon
                        class="white--text material-symbols-outlined"
                        :color="primaryColor"
                        aria-hidden="true"
                        data-qa="casadetails-icon-nn17k">
                        info
                      </v-icon>
                    </v-btn>
                  </template>
                  <font v-if="this.defaultAccountType === 'TXEA'" class="white--text">{{
                    $t("transferOut.infoMessage")
                  }}</font>
                  <font v-else class="white--text">{{
                    $t("transferOut.fixedRateInfoMessage")
                  }}</font>
                </v-tooltip>
              </v-layout>
            </v-row>
            <v-row class="px-1" data-qa="casadetails-row-6yfibe">
              <v-layout wrap data-qa="casadetails-layout-fs42y">
                <v-col data-qa="casadetails-flex-cea62">
                  <v-row data-qa="casadetails-layout-j7edqn">
                    <v-col
                      cols="12"
                      sm="auto"
                      class="px-4 pb-0"
                      data-qa="casadetails-col-account-id"
                    >
                      <span class="subheading font-weight-medium white--text d-block"
                        v-text="$t('accountDetails.accountNumber')" />
                      <span class="text-h5 font-weight-bold white--text d-block"
                        v-text="formattedAccountId" />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="auto"
                      class="px-4"
                      data-qa="casadetails-col-balance-info"
                    >
                      <span class="subheading font-weight-medium white--text d-block"
                        v-text="isFixedRateCashIsaAccount || isNoticeCashIsaAccount
                          ? $t('accountDetails.availableBalance')
                          : $t('accountDetails.accountBalance')"/>
                      <span
                        v-if="!isFetchingData"
                        class="text-h5 font-weight-bold white--text text-no-wrap d-block"
                        v-text="getBalInfo(casaDetails)" />
                    </v-col>
                    <v-col
                      v-if="isNoticeAccount || isNoticeCashIsaAccount"
                      cols="12"
                      sm="auto"
                      class="px-4"
                      data-qa="casadetails-col-amount-on-notice"
                    >
                      <span class="subheading font-weight-medium white--text d-block"
                        v-text="$t('accountDetails.amountOnNotice')"/>
                      <span
                        class="text-h5 font-weight-bold white--text text-no-wrap d-block"
                        v-text="$formatter.currency.format(totalNoticeIssued, currency)"/>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- HEADER BUTTONS -->
                <!--TXFR (Fixed Rate) -->
                <v-col
                  v-if="(isFixedRateCashIsaAccount && !isAccountRestricted && !isSmeLogin && isActive) && !disableAmendMIButton"
                >
                  <v-row v-bind="headerButtonsRowProps">
                    <v-col v-bind="headerButtonColProps">
                      <v-tooltip
                        v-if="!withinMaturityDateRange"
                        top
                        content-class="v-tooltip__content_amend"
                        data-qa="casadetails-tooltip-ugztt"
                      >
                        <template v-slot:activator="{ on }">
                          <div v-on="on" data-qa="casadetails-div-3qxn6c">
                            <v-btn
                              :class="headerButtonClass"
                              :disabled="!withinMaturityDateRange"
                              @click="amendTaxAccount(accountId)"
                              dark
                              outlined
                              data-qa="casadetails-btn-6dtsxv"
                            >
                              {{ $t("taxAccountDetails.amend") }}
                              <v-icon class="pl-2 material-symbols-outlined" v-if="!withinMaturityDateRange" size="18px" data-qa="casadetails-icon-kcd5ab">help</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <font class="white--text">
                          {{ $t("termdepositDetails.disabledAmendTooltip") }}
                        </font>
                      </v-tooltip>
                      <v-btn v-else
                        :disabled="!withinMaturityDateRange"
                        @click="amendTaxAccount(accountId)"
                        :class="headerButtonClass"
                        dark
                        outlined
                        data-qa="casadetails-btn-l7bs3"
                      >
                        {{ $t("taxAccountDetails.amend") }}
                        <v-icon class="pl-2 material-symbols-outlined" v-if="!withinMaturityDateRange" size="18px" data-qa="casadetails-icon-6397pw">help</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col
                      v-if="fixedRateAccClosure.enableClosedBtn"
                      v-bind="headerButtonColProps"
                    >
                      <v-btn
                        @click="closeAccount"
                        :class="headerButtonClass"
                        outlined
                        data-qa="casadetails-btn-ly382q"
                        v-text="$t('accountDetails.closeAccBtnLabel')"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <!-- CASA buttons with debit cards -->
                <v-col
                  v-if="(!isNoticeAccount && !isFixedRateCashIsaAccount && !isInstantCashIsaAccount && !isLifetimeIsaAccount && !isNoticeCashIsaAccount && !isAccountRestricted && !isSmeLogin && !isTransferARIRestricted && debitCardsFound)"
                  data-qa="casadetails-flex-3ecrqm"
                >
                  <v-row v-bind="headerButtonsRowProps">
                    <v-col v-bind="headerButtonColProps">
                      <v-btn
                        @click="viewDebit(accountId)"
                        :class="headerButtonClass"
                        outlined
                        data-qa="casadetails-btn-okxyna">{{ $t("accountDetails.btnViewDebit") }}
                      </v-btn>
                    </v-col>
                    <v-col v-bind="headerButtonColProps">
                      <v-btn
                        v-if="isActive && isTransferFundsPermitted"
                        @click="routeTo(accountId)"
                        :class="headerButtonClass"
                        outlined
                        data-qa="casadetails-btn-29wvg"
                        v-text="sameTypeTaxAcc.includes(defaultAccountType)
                          ? $t('accountDetails.cashISABtnLabel')
                          : $t('accountDetails.btnTransfer')"
                      />
                    </v-col>
                    <v-col v-bind="headerButtonColProps">
                      <v-btn
                        v-if="savingsAccClosure.enableClosedBtn"
                        @click="closeAccount"
                        :class="headerButtonClass"
                        outlined
                        v-text="$t('accountDetails.closeAccBtnLabel')"
                        data-qa="casadetails-btn-k5gcjp"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <!-- CASA buttons without debit cards -->
                <v-col
                  v-if="(!isNoticeAccount && !isFixedRateCashIsaAccount && !isNoticeCashIsaAccount && !isAccountRestricted && !isTransferARIRestricted && !debitCardsFound && !isLifetimeIsaAccount && !cashISATypes.includes(defaultAccountType)) && isActive"
                  data-qa="casadetails-flex-eybus9"
                >
                  <v-row v-bind="headerButtonsRowProps">
                    <v-col
                      v-if="isAccountValidModeOfOperation"
                      v-bind="headerButtonColProps"
                    >
                      <v-btn
                        v-if="isTransferFundsPermitted&&enableFundsTransferButton"
                        @click="routeTo(accountId)"
                        :class="headerButtonClass"
                        outlined
                        :disabled="availableBalance === 0"
                        data-qa="casadetails-btn-ztblcl"
                        v-text="sameTypeTaxAcc.includes(defaultAccountType)
                          ? $t('accountDetails.cashISABtnLabel')
                          : $t('accountDetails.btnTransfer')"
                      />
                    </v-col>
                    <v-col
                      v-if="(savingsAccClosure.enableClosedBtn || (currentAccClosure.enableClosedBtn && defaultAccountType === 'CACC'))"
                      v-bind="headerButtonColProps"
                    >
                      <v-btn
                        @click="closeAccount"
                        :class="headerButtonClass"
                        outlined
                        data-qa="casadetails-btn-og7tym"
                        v-text="$t('accountDetails.closeAccBtnLabel')"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <!-- TXEA buttons -->
                <v-col
                  v-if="(!isNoticeAccount && !isFixedRateCashIsaAccount && !isNoticeCashIsaAccount && !isAccountRestricted && !isSmeLogin && !isTransferARIRestricted && !debitCardsFound && cashISATypes.includes(defaultAccountType) && !accCloseRestriction) && isActive"
                  data-qa="casadetails-flex-wizzcb"
                >
                  <v-row v-bind="headerButtonsRowProps">
                    <v-col v-bind="headerButtonColProps">
                      <v-btn
                        v-if="isTransferFundsPermitted"
                        @click="routeTo(accountId)"
                        :class="headerButtonClass"
                        outlined
                        :disabled="availableBalance === 0"
                        data-qa="casadetails-btn-pol74b"
                        v-text="sameTypeTaxAcc.includes(defaultAccountType) ? $t('accountDetails.cashISABtnLabel') : $t('accountDetails.btnTransfer')"
                      />
                    </v-col>
                    <v-col
                      v-if="instantCashAccClosure.enableClosedBtn"
                      v-bind="headerButtonColProps"
                    >
                      <v-btn
                        @click="closeAccount"
                        :class="headerButtonClass"
                        outlined
                        data-qa="casadetails-btn-ihyl8f"
                        v-text="$t('accountDetails.closeAccBtnLabel')"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-flex v-if="(!isNoticeAccount && !isFixedRateCashIsaAccount && !isNoticeCashIsaAccount && !isAccountRestricted && isSmeLogin && debitCardsFound)" lg3 xl3 data-qa="casadetails-flex-rqei8">
                  <v-layout row class="pa-4 text-right" data-qa="casadetails-layout-ou4le">
                    <v-flex xs12 sm12 md12 lg12 xl12  data-qa="casadetails-flex-55bukr">
                      <v-btn
                        @click="viewDebit(accountId)"
                        :class="headerButtonClass"
                        outlined
                        v-text="$t('accountDetails.btnViewDebit')"
                        data-qa="casadetails-btn-1cayfe"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- Lifetime (TXLA) buttons -->
                <v-col
                  v-if="isLifetimeIsaAccount && !isAccountRestricted && !isSmeLogin"
                  data-qa="casadetails-flex-0aa5so"
                >
                  <v-row
                    v-bind="headerButtonsRowProps"
                    data-qa="casadetails-layout-vlnkgq"
                  >
                    <v-col
                      v-if="isAccountValidModeOfOperation"
                      v-bind="headerButtonColProps"
                      data-qa="casadetails-flex-uc35u"
                    >
                      <v-btn
                        @click="routeTo(accountId)"
                        :class="headerButtonClass"
                        outlined
                        :disabled="availableBalance === 0"
                        v-text="sameTypeTaxAcc.includes(defaultAccountType)
                          ? $t('accountDetails.cashISABtnLabel')
                          : $t('accountDetails.btnTransfer')"
                        data-qa="casadetails-btn-0bknbh"
                      />
                    </v-col>
                    <v-col
                      v-bind="headerButtonColProps"
                      data-qa="casadetails-flex-oulpf"
                    >
                      <v-btn
                        v-if="showLisaTransferInBtn"
                        @click="transferIn(accountId)"
                        :class="headerButtonClass"
                        rounded
                        outlined
                        v-text="$t('accountDetails.transferInBtnLabel')"
                        data-qa="casadetails-btn-trawwn"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <!-- Notice (NACC/TXNA) buttons -->
                <v-col
                  v-if="shouldShowNoticeButtons"
                  data-qa="col-notice-buttons"
                >
                  <v-row v-bind="headerButtonsRowProps">
                    <v-col
                      v-for="(btn, index) in filteredNoticeButtons"
                      :key="index"
                      v-bind="headerButtonColProps"
                    >
                      <v-btn
                        :data-qa="btn.qa"
                        @click="btn.click"
                        :class="headerButtonClass"
                        outlined
                        v-text="btn.text"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>

    <v-tabs v-model="currentTab" :color="primaryColor" class="pl-2" v-if="!isFetchingData" data-qa="casadetails-tabs-5zxmbt">
      <v-tab v-for="(item, i) in getTabLabels()" :key="i" class="px-6" :data-qa="`casadetails-tab-k3gbqc-${i}`">
        <font class="subtitle-1 text-capitalize font-weight-bold px-6">{{ item }}</font>
      </v-tab>
    </v-tabs>

    <v-container fluid v-if="!isFetchingData" data-qa="casadetails-container-iki0rf">
      <v-flex lg10 data-qa="casadetails-flex-80mf">
        <v-tabs-items v-model="currentTab" data-qa="casadetails-tabs-items-6v6um">
          <!-- Transactions Tab-->
          <v-tab-item xl12 lg12 sm10 xs12 data-qa="casadetails-tab-item-rpciu9">
            <v-row :style="{ background: defaultBackgroundColor }" data-qa="casadetails-row-kwjz9l3">
              <Transactions
                v-if="transactionList && !isAccountRestricted && fetchAccTypePermissions(defaultAccountType, 'transactions')"
                :config="{ postingRestrictionType, defaultAccountType }"
              />
            </v-row>
            <v-row
              v-if="!(fetchAccTypePermissions(defaultAccountType, 'transactions'))"
              no-gutters
              justify="center"
              class="ma-6 ml-0"
            >
              <div outlined class="text-center pa-6">
                <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                  <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                </p>
              </div>
            </v-row>
          </v-tab-item>
          <!-- Details Tab-->
          <v-tab-item data-qa="casadetails-tab-item-6sknh">
            <v-row v-if="(fetchAccTypePermissions(defaultAccountType, 'details'))" :style="{ background: defaultBackgroundColor }" class="pl-2" data-qa="casadetails-row-ytwams">
              <v-card tile class="py-2 pt-4" data-qa="casadetails-card-p7s0l">
                <DisplayDetails
                  v-if="casaDetails?.length"
                  :config="{
                    title: $t('accountDetails.accInfo'),
                    dataList: casaDetails,
                    accountIdUpdate: accountId,
                    translation: 'accountDetails'
                  }"
                  @onIconClick="onIconClick($event)"
                  class="pl-5"
                />
                <v-divider data-qa="casadetails-divider-krywml"
                  v-if=" creditInterestDetails && creditInterestDetails.length && !isNoticeCashIsaAccount"
                  class="pa-3"
                />
                <DisplayDetails
                  v-if=" creditInterestDetails && creditInterestDetails.length && !isNoticeCashIsaAccount"
                  :config="{
                    title: (defaultAccountType === 'SVGS' || isNoticeAccount || isFixedRateCashIsaAccount)
                      ? this.$t('accountDetails.interestDetails') : this.$t('accountDetails.creditInterestDetails'),
                    dataList: creditInterestDetails,
                    translation: 'accountDetails'
                  }"
                  class="pl-5 pb-2"
                />
                <v-divider data-qa="casadetails-divider-itll1kj"
                  v-if="
                      defaultAccountType === 'CACC' &&
                      debitInterestDetails &&
                      debitInterestDetails.length
                  "
                  class="pa-3"
                />
                <DisplayDetails
                  v-if="
                    defaultAccountType === 'CACC' &&
                      debitInterestDetails &&
                      debitInterestDetails.length
                  "
                  :config="{
                    title: $t('accountDetails.debitInterestDetails'),
                    dataList: debitInterestDetails,
                    translation: 'accountDetails'
                  }"
                  class="pl-5 pt-6 pb-2"
                />
                <v-divider data-qa="casadetails-divider-pbxa"
                  v-if="
                    (isNoticeAccount ||isNoticeCashIsaAccount) &&
                      noticeDetails &&
                      noticeDetails.length
                  "
                  class="mt-4"
                />
                <DisplayDetails
                  v-if="(isNoticeAccount || isNoticeCashIsaAccount) && noticeDetails && noticeDetails.length"
                  :config="{
                    title: isNoticeCashIsaAccount ? $t('accountDetails.productDetails') : $t('accountDetails.noticeDetails'),
                    dataList: noticeDetails,
                    translation: 'noticeAccountDetails'
                  }"
                  class="pl-5 pt-6 pb-2"
                />
                <v-divider data-qa="casadetails-divider-n5cdj"
                  v-if="
                    (defaultAccountType === 'TXSV' || isFixedRateCashIsaAccount || isNoticeCashIsaAccount || isInstantCashIsaAccount || isLifetimeIsaAccount) &&
                    taxAccDetails &&
                    taxAccDetails.length
                  "
                  class="mt-4"
                />
                <DisplayDetails
                  v-if="
                    (defaultAccountType === 'TXSV' || isFixedRateCashIsaAccount || isNoticeCashIsaAccount || isInstantCashIsaAccount || isLifetimeIsaAccount) &&
                    taxAccDetails && taxAccDetails.length
                  "
                  :config="{
                    title: isNoticeCashIsaAccount ? $t('taxAccountDetails.isaAllowance') : $t('taxAccountDetails.title'),
                    dataList: taxAccDetails,
                    translation: 'taxAccountDetails'
                  }"
                  class="pl-5 pt-6 pb-2"
                />
                <!--ISA Allowance: Previous Year Subscription details-->
                <v-divider data-qa="casadetails-divider-biigzg"
                  v-if="
                      (defaultAccountType === 'TXSV' || isFixedRateCashIsaAccount || isInstantCashIsaAccount || isLifetimeIsaAccount) &&
                      taxAccDetails && taxAccDetails.length
                  "
                  class="mt-4"
                />
                <DisplayDetails
                  v-if="
                    (defaultAccountType === 'TXSV' || isFixedRateCashIsaAccount || isInstantCashIsaAccount || isLifetimeIsaAccount) &&
                    taxAccDetails && taxAccDetails.length
                  "
                  :config="{
                    title: $t('taxAccountDetails.previousYearISAtitle'),
                    dataList: taxAccDetailsPreviousYear,
                    translation: 'taxAccountDetails'
                  }"
                  class="pl-5 pt-6 pb-2"
                />
                <!-- Maturity Instruction Details -->
                <v-divider data-qa="casadetails-divider-xgrw8"
                  v-if="
                      defaultAccountType === 'TXSV' &&
                      taxAccDetails && taxAccDetails.length ||
                      isFixedRateCashIsaAccount &&
                      taxAccDetails && taxAccDetails.length
                  "
                  class="mt-4"
                />
                <DisplayDetails
                  v-if="
                    isFixedRateCashIsaAccount &&
                    taxAccDetails && taxAccDetails.length
                  "
                  :config="{
                    title: $t('taxAccountMaturityDetails.title'),
                    dataList: taxAccMaturityDetails,
                    translation: 'taxAccountMaturityDetails'
                  }"
                  class="pl-5 pt-6 pb-2"
                />
                <template v-if='isNoticeCashIsaAccount && noticeCashIsaCreditInterestDetails?.length'>
                  <v-divider data-qa="casadetails-divider-z677l"  class="mt-4"/>
                  <DisplayDetails
                    :config="{
                        title: $t('accountDetails.creditInterestDetails'),
                        dataList: noticeCashIsaCreditInterestDetails,
                        translation: 'accountDetails'
                      }"
                      class="pl-5 pt-6 pb-2"
                  />
                </template>
              </v-card>
            </v-row>
            <v-row v-if="!casaDetails?.length && fetchAccTypePermissions(defaultAccountType, 'details')" class="pl-4" data-qa="casadetails-row-2ewwt">
              <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="casadetails-alert-was9o">
                <font class="body-2">
                  {{ $t('casaDetails.noAvailableInfo') }}
                </font>
              </v-alert>
            </v-row>
            <v-row
                v-if="!(fetchAccTypePermissions(defaultAccountType, 'details'))"
                no-gutters
                justify="center"
                class="ma-6 ml-0"
              >
                <div outlined class="text-center pa-6">
                  <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                    <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                  </p>
                </div>
            </v-row>
          </v-tab-item>
          <!-- Notice Accounts Notices Placed Tab -->
          <v-tab-item v-if="isNoticeAccount || isNoticeCashIsaAccount" data-qa="casadetails-tab-item-ehbwak">
            <div v-if="fetchAccTypePermissions(defaultAccountType, 'placeNotice')">
            <v-flex
              v-if="((noticeList && !noticeList.length) || !noticeList)"
              xs12
              sm6
              md5
              lg5
              xl4
              class="text-left px-4 pt-4"
              data-qa="casadetails-flex-gvmyl">
              <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="casadetails-alert-5nftn3">
                <font class="body-2">
                  {{ $t("noticeAccountDetails.noNoticePlaced") }}
                </font>
              </v-alert>
            </v-flex>
            <v-flex v-else class="pa-2" data-qa="casadetails-flex-1qflvs">
              <v-chip-group
                :color="primaryColor"
                column
                data-qa="casadetails-chip-group-om55f4">
                <v-chip
                  v-for="(status, i) in filterableStatuses"
                  :key="status"
                  outlined
                  class="ma-2"
                  :color="primaryColor"
                  @click="selectedFilterStatus = status"
                  :data-qa="`casadetails-chip-wf1v1s-${i}`"
                >
                  <font class="text-capitalize">{{
                    $t(`systemEnums.noticeAccountsFilters.${status}`)
                  }}</font>
                </v-chip>
              </v-chip-group>
              <span class="pl-2" data-qa="casadetails-span-izozj">
                <v-btn
                  v-if="!disableFilterReset"
                  @click="selectedFilterStatus = 'reset'"
                  :disabled="disableFilterReset"
                  :color="secondaryColor"
                  outlined
                  class="body-2 text-capitalize pa-2 py-2 px-4"
                  data-qa="casadetails-btn-etndvm">
                  <v-icon
                    :disabled="disableFilterReset"
                    :color="secondaryColor"
                    left
                    data-qa="casadetails-icon-t8q5yi">mdi-refresh</v-icon
                  >
                  {{ $t("termdepositDetails.btnResetFilter") }}
                </v-btn></span
              >
              <v-flex
                v-if="noticeList && noticeList.length"
                xs12
                sm10
                md8
                lg7
                xl7
                class="pa-2 mt-2"
                data-qa="casadetails-flex-9vmpvq">
                <v-card class="text-left status--hover" data-qa="casadetails-card-lx5mdw">
                  <div
                    v-for="(account, index) in filterIssuedNotices()"
                    :key="index"
                    :data-qa="`casadetails-div-qc4i5s-${index}`">
                    <v-list-item
                      two-line
                      @click="selectedPayment(account, index)"
                      :data-qa="`casadetails-list-item-o0r2s-${index}`">
                      <v-list-item-content :data-qa="`casadetails-list-item-content-aicc1l-${index}`">
                        <div class="mb-0" :data-qa="`casadetails-div-5uvuj-${index}`">
                          <font :color="getStatusColor(account.noticeStatus)">
                            <v-list-item-title :data-qa="`casadetails-list-item-title-mj9vf-${index}`">
                              {{ getNoticeAccStatus(account.noticeStatus) }}
                            </v-list-item-title>
                          </font>
                        </div>
                        <v-list-item-subtitle  class="py-2" :data-qa="`casadetails-list-item-subtitle-q9vsi-${index}`">
                          {{ getNoticeAccDate(account) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action :data-qa="`casadetails-list-item-action-ik817c-${index}`">
                        <v-list-item-action-text :data-qa="`casadetails-list-item-action-text-2xdmr8-${index}`">
                          <font class="subtitle-1 font-weight-bold">{{
                            $formatter.currency.format(
                              account.noticeAmount.amount,
                              account.noticeAmount.currency
                            )
                          }}</font>
                        </v-list-item-action-text>
                      </v-list-item-action>
                      <v-icon class="text-end" :data-qa="`casadetails-icon-yjz0bs-${index}`">mdi-chevron-right</v-icon>
                    </v-list-item>
                    <v-divider :data-qa="`casadetails-divider-z1at78-${index}`"></v-divider>
                  </div>
                </v-card>
              </v-flex>
            </v-flex>
            <v-flex
              v-if="noticeList && noticeList.length"
              xs12
              sm6
              md5
              lg5
              xl4
              class="text-left pt-4 px-4"
              data-qa="casadetails-flex-myu3gm">
              <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="casadetails-alert-3gypsl">
                <font class="body-2">
                  {{ $t("noticeAccountDetails.oneYearNoticesMsg") }}
                </font>
              </v-alert>
            </v-flex>
            </div>
            <v-row
              v-if="!(fetchAccTypePermissions(defaultAccountType, 'placeNotice'))"
              no-gutters
              justify="center"
              class="ma-6 ml-0"
            >
              <div outlined class="text-center pa-6">
                <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                  <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                </p>
              </div>
            </v-row>
          </v-tab-item>
          <!-- Lisa Transfer-In Tab-->
          <v-tab-item v-if='isLifetimeIsaAccount && enableLisaTransferIn' data-qa="casadetails-tab-item-3zzjlg">
            <v-flex
              v-if="(transferInData && !transferInData.length) || !transferInData"
              xs12
              sm12
              md8
              lg6
              xl6
              class="pa-2"
              data-qa="casadetails-flex-4653cr">
              <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="casadetails-alert-sjlm1j">
                <font class="body-2">
                  {{ $t("lisaAccountDetails.noTransferInRequest") }}
                </font>
              </v-alert>
            </v-flex>
            <v-flex v-else :style="{ background: defaultBackgroundColor }" data-qa="casadetails-flex-fogmqc">
              <TransferInStatus :config="transferInData"></TransferInStatus>
            </v-flex>
          </v-tab-item>
          <!-- List the statements Tab-->
          <v-tab-item data-qa="casadetails-tab-item-9uia3d">
            <v-list v-if="eStatementList.length && fetchAccTypePermissions(defaultAccountType, 'statements')" class="px-5" data-qa="casadetails-list-i5lqk">
              <v-list-item-content
                v-for="(statement, index) in eStatementList"
                :key="index"
                :data-qa="`casadetails-list-item-content-iw31kc-${index}`">
                <v-card-text class="pa-2" :data-qa="`casadetails-card-text-7wgimh-${index}`">
                  <v-layout wrap :data-qa="`casadetails-layout-h74f4c-${index}`">
                    <v-flex xs12 sm12 md12 lg5 xl7 :data-qa="`casadetails-flex-yuq92h-${index}`">
                      <span
                        class="body-1 font-weight-regular"
                        v-text="statement.data"
                        :data-qa="`casadetails-span-6070nl-${index}`"></span>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg4 xl5 :data-qa="`casadetails-flex-6h5hpx-${index}`">
                      <v-btn
                        @click="downloadStatement('view', statement.documentId)"
                        text
                        :color="primaryColor"
                        :data-qa="`casadetails-btn-zvmkr-${index}`">
                        <v-icon left class="material-symbols-outlined" size="18px" :data-qa="`casadetails-icon-u7ik2t6-${index}`">visibility</v-icon>
                        <font class="body-2 font-weight-regular">
                          {{ $t("consolidatedStatement.viewBtn") }}</font
                        >
                      </v-btn>
                      <v-btn
                        @click="
                          downloadStatement('download', statement.documentId)
                        "
                        text
                        :color="primaryColor"
                        :data-qa="`casadetails-btn-kzvfe-${index}`">
                        <v-icon left class="material-symbols-outlined" :data-qa="`casadetails-icon-ha1i4-${index}`">download</v-icon>
                        <font class="body-2 font-weight-regular">{{
                          $t("consolidatedStatement.downloadBtn")
                        }}</font>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider :data-qa="`casadetails-divider-rzhhy-${index}`"  v-if="!(index === eStatementList.length - 1)" />
              </v-list-item-content>
            </v-list>
            <v-row
              v-if="
                fetchAccTypePermissions(defaultAccountType, 'statements') &&
                ((!eStatementList.length && noStatementsAvail) ||
                  (!eStatementList.length && noStatementFound))
              "
              no-gutters
              justify="center"
              class="ma-6 ml-0"
              data-qa="casadetails-row-wrmrx89">
              <div outlined class="text-center pa-6" data-qa="casadetails-div-jcxdz">
                <v-icon x-large :color="primaryColor" class="pb-3"
                  data-qa="casadetails-icon-2bxcjc">mdi-file-document</v-icon
                >
                <p v-if="noStatementsAvail" :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }" data-qa="casadetails-p-pvuo4h">
                  {{ $t("accountStatements.noStatementsAvailable") }}
                </p>
                <p v-if="noStatementFound" :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }" data-qa="casadetails-p-5do9dr">
                  {{ $t("accountStatements.noStatementFound") }}
                </p>
              </div>
            </v-row>
            <v-row
                v-if="!(fetchAccTypePermissions(defaultAccountType, 'statements'))"
                no-gutters
                justify="center"
                class="ma-6 ml-0"
              >
                <div outlined class="text-center pa-6">
                  <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                    <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                  </p>
                </div>
              </v-row>
          </v-tab-item>
          <!-- Payment Status statements Tab-->
          <v-tab-item data-qa="casadetails-tab-item-nza94u">
            <v-row v-if="!isAccountRestricted && postingRestrictionType != 'DEBITCREDIT' && fetchAccTypePermissions(defaultAccountType, 'paymentStatus')" :style="{ background: defaultBackgroundColor }" data-qa="casadetails-row-1pbd1h">
              <PaymentStatus :config="accountId"></PaymentStatus>
            </v-row>
            <v-row
                v-if="(!(fetchAccTypePermissions(defaultAccountType, 'paymentStatus')))"
                no-gutters
                justify="center"
                class="ma-6 ml-0"
              >
                <div outlined class="text-center pa-6">
                  <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                    <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                  </p>
                </div>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
        <v-flex
          v-if="isAccountRestricted || postingRestrictions.info"
          xs12
          sm12
          md12
          lg12
          xl9
          class="mt-1"
          data-qa="casadetails-flex-bz3vsj">
          <v-alert
            icon="mdi-alert-outline"
            class="v-alert--warning"
          data-qa="casadetails-alert-4y5j2">
            <span class="body-2 font-weight-regular" data-qa="casadetails-span-dv7cnl">{{ postingRestrictions.info }}</span>
          </v-alert>
        </v-flex>
    </v-container>
    <v-flex class="mb-1" v-if="tips.enabled" data-qa="casadetails-flex-u964nq">
      <v-alert
        icon="mdi-information-outline"
        class="v-alert--info"
        v-for="(tip, i) in tips.tipMessages"
        :key="tip"
        :data-qa="`casadetails-alert-2j8vnq-${i}`"
      >
        <font class="body-2 font-weight-regular">
          {{ $t(`screenTips.${tip}`) }}
        </font>
      </v-alert>
    </v-flex>

    <!-- Doc preview -->
    <PDFPreview v-if="viewPDF" :PDFData="PDFData" @closePdfPreview="viewPDF= false"/>
    <!-- Modal Notice Accounts Notices Placed Details -->
    <Modal
      :config="placeNoticeDetails"
      @btn1Action="cancelNoticeHandler"
      @btn2Action="modalConfig.noticeDetails.enabled = false"
    >
      <span slot="modalContent" data-qa="casadetails-span-na4im6">
        <div class="text--primary pt-0" data-qa="casadetails-div-02fxz">
          <v-row no-gutters data-qa="casadetails-row-tdi16k">
            <v-col
              v-for="(item, i) in placedNoticeDetails"
              :key="i"
              cols="6"
              class="px-6 pt-3 pl-0"
              :data-qa="`casadetails-col-m0z1q-${i}`">
              <div class="pa-1 overline font-weight-bold" :data-qa="`casadetails-div-v5fuqu-${i}`">
                {{ $t(`noticeAccountDetails.${item.label}`) }}
              </div>
              <div class="px-1 mt-n1" :data-qa="`casadetails-div-qktac9-${i}`">
                {{ item.value }}
              </div>
            </v-col>
          </v-row>
        </div>
      </span>
    </Modal>
    <!-- Confirmation modal to cancel notice-->
    <Modal
      v-if="showConfirmationModal"
      :config='modalConfig.cancelPlaceNotice'
      @btn1Action="viewCancelledNoticeDetails">
    </Modal>
    <Modal
      v-if="enableCloseAccount"
      :config='modalConfig.closeAccount'
      @btn1Action="onContinueClose(accountId)"
      @btn2Action="onCancel()">
    </Modal>
    <NoticeCashIsaWarning
      v-if="showNoticeCashIsaTransferOutWarning"
      :subtitle="$t('noticeCashIsa.transferOut.warning.subtitle')"
      :text="$t('noticeCashIsa.transferOut.warning.text', { date: noticeWithdrawalDate.DMY })"
      @onCancel="showNoticeCashIsaTransferOutWarning = false"
      @onContinue="handleNoticeCashISATransferOutContinue"
    />
    <NoticeCashIsaWarning
      v-if="showNoticeCloseAccountWarning"
      :subtitle="$t('noticeCashIsa.closeAccount.warning.subtitle')"
      :text="isNoticeAccount ? $t('common.closeAccountMessage') : $t('noticeCashIsa.closeAccount.warning.text')"
      @onCancel="showNoticeCloseAccountWarning = false"
      @onContinue="handleNoticeCashIsaCloseAccountContinue"
    />
    <NoticeCashIsaSuccess
      v-if="showTransferOutSuccessfulDialog"
      :subtitle="$t('noticeCashIsa.transferOut.success.subtitle')"
      :text="$t('noticeCashIsa.transferOut.success.text', { date: noticeWithdrawalDate.DMY })"
      @onViewNoticeClick="handleNoticeCashIsaViewNoticeClick"
      @onGotoDashboardClick="handleNoticeCashIsaGotoDashboardClick"
    />
    <!-- OTP section to place notice -->
    <Modal
      v-if="showOTPScreen"
      :config="otpModalConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="casadetails-span-tpswj">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
  </v-layout>
</template>

<script>
import commonService from '@/service/commonService.js'
import Transactions from '@/views/accounts/Transactions'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import PaymentStatus from '@/views/accounts/PaymentStatus'
import OtpInput from '@/components/common/OtpInput.vue'
import _ from 'lodash'
import moment from 'moment'
import event from '@/util/event'
import store from '@/core/store'
import Loader from '../../../components/common/Loader.vue'
import PDFPreview from '@/components/common/PDFPreview.vue'

export default {
  name: 'CasaDetails',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  components: {
    PDFPreview,
    Loader,
    Transactions,
    DisplayDetails,
    PaymentStatus,
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput,
    NoticeCashIsaSuccess: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaSuccess.vue'),
    NoticeCashIsaWarning: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaWarning.vue'),
    TransferInStatus: () => import('@/views/accounts/accountDetails/lifetimeISA/TransferInStatus.vue')
  },
  data () {
    return {
      /** the prop 'isFetchingData' is used to delay the page rendering -> we need to wait until getAccountDetails() is finished */
      isFetchingData: true,
      curYrSubAmtUsd: 0,
      accountId: '',
      isNoticeCashIsaAccount: false,
      isFixedRateCashIsaAccount: false,
      isInstantCashIsaAccount: false,
      isLifetimeIsaAccount: false,
      sameTypeTaxAcc: ['TXSV', 'TXEA', 'TXLA'],
      cashISATypes: ['TXNA', 'TXFR', 'TXEA'],
      isCashIsaAccount: ['TXNA', 'TXFR', 'TXEA', 'TXLA'].includes(this.config.params.defaultAccountType),
      instCashIsaStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      casaDetails: [],
      nominatedAccount: '',
      enablePlaceNotice: this.$appSettings.defaultConfigurations.accountDetailsScreen.enablePlaceNotice,
      enableCancelNotice: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableCancelNotice,
      enableLisaTransferIn: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableLisaTransferIn,
      isAccruedPenaltyEnabled: this.$appSettings.defaultConfigurations.enableAccruedPenaltyCharges,
      enableCloseAccount: false,
      accCloseRestriction: false,
      transactionList: true,
      availableBalance: undefined,
      minimumBalance: undefined,
      currentTab: 0,
      sortCode: '',
      currency: '',
      productId: '',
      voidedAmount: '',
      postingRestrictionType: '',
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: '',
      eStatementList: [],
      noticeList: [],
      noStatementsAvail: true,
      noStatementFound: false,
      statementDoc: undefined,
      postingRestrictions: {
        info: '',
        color: ''
      },
      tips: {
        enabled: false,
        tipMessages: []
      },
      noticeAccTabLabels: [
        this.$t('noticeAccountDetails.tabs.tab1'),
        this.$t('noticeAccountDetails.tabs.tab2'),
        this.$t('noticeAccountDetails.tabs.tab3'),
        this.$t('noticeAccountDetails.tabs.tab4'),
        this.$t('noticeAccountDetails.tabs.tab5')
      ],
      lisaAccTabLabels: [
        this.$t('lisaAccountDetails.tabs.tab1'),
        this.$t('lisaAccountDetails.tabs.tab2'),
        this.$t('lisaAccountDetails.tabs.tab3'),
        this.$t('lisaAccountDetails.tabs.tab4'),
        this.$t('lisaAccountDetails.tabs.tab5')
      ],
      transferInData: {},
      noticeProductDetails: {},
      noticeAccDetails: {},
      taxAccDetails: [],
      showTransferOut: false,
      taxAccDetailsPreviousYear: [],
      taxAccMaturityDetails: [],
      noticeDetails: [],
      casaAccountDetails: {},
      placedNoticeDetails: [],
      cancelledNotices: [],
      selectedFilterStatus: 'ISSUED',
      noticeAccountStatus: '',
      accountCurrency: '',
      selectedNoticeDetails: {},
      creditInterestDetails: [],
      noticeCashIsaCreditInterestDetails: [],
      debitInterestDetails: [],
      disableFilterReset: true,
      showConfirmationModal: false,
      loaderEnabled: false,
      isAccountRestricted: false,
      isTransferARIRestricted: false,
      showOTPScreen: false,
      modalConfig: {
        closeAccount: {
          enabled: true,
          title: this.$t('closeAccount.popUpMessage'),
          body: '',
          persistent: true,
          btn1Label: this.$t('closeAccount.btnContinue'),
          btn2Label: this.$t('closeAccount.btnCancel'),
          width: 500
        },
        cancelPlaceNotice: {
          enabled: true,
          title: this.$t('cancelNotice.confirmationModalTitle'),
          body: this.$t('cancelNotice.subtitle'),
          persistent: true,
          btn1Label: this.$t('cancelNotice.viewNoticeDetailsBtnLabel'),
          width: 500
        },
        noticeDetails: {
          enabled: false
        }
      },
      otpModalConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      filterableStatuses: [],
      enableAccountsInterestDetails: this.$appSettings.defaultConfigurations.enableAccountsInterestDetailsEnquiry,
      enableNominatedAccounts: this.$appSettings.defaultConfigurations.nominatedAccounts.enableNominatedAccountFeatures,
      enableNoticeSection: this.$appSettings.defaultConfigurations
        .landingPageConfig.enableNoticeSection,
      enableOTPToCancelNotice: this.$appSettings.defaultConfigurations.enableOTPToCancelNotice,
      enableInstCashAccCloseOption: this.$appSettings.defaultConfigurations.instantCashAccClosure.enableInstCashAccCloseOption,
      enableSavingsAccountClosureOption: this.$appSettings.defaultConfigurations.savingsAccountClosure.enableSavingsAccountClosureOption,
      enableCurrentAccClosureOption: this.$appSettings.defaultConfigurations.currentAccountClosure.enableCurrentAccClosureOption,
      enableFixedRateAccClosureOption: this.$appSettings.defaultConfigurations.fixedRateAccClosure.enableFixedRateAccClosureOption,
      enableTransferOutInfo: this.$appSettings.defaultConfigurations.enableTransferOutInfo,
      isShowAccountType: this.$appSettings.isShowAccountType,
      isShowSortcode:this.$appSettings.isShowSortcode,
      enableFundsTransferButton: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableFundsTransferButton,
      clearedBalance: undefined,
      isNoticeAccount: this.config.params.defaultAccountType === 'NACC',
      debitCardsFound: false,
      isActive: false,
      disableAmendMIButton: false,
      transferBtnLabel: 'accountDetails.btnTransfer',
      currentAccClosure: {
        enableClosedBtn: false,
        restrictedCashIsaStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
        postingsRestrictions: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'DEBIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF']
      },
      savingsAccClosure: {
        enableClosedBtn: false,
        restrictedCashIsaStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
        postingsRestrictions: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'DEBIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF']
      },
      instantCashAccClosure: {
        enableClosedBtn: false,
        restrictedAccStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
        postingsRestrictions: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'DEBIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF']
      },
      enableDebitCard: this.$appSettings.defaultConfigurations.cards.enableDebitCard,
      viewPDF: false,
      PDFData: undefined,
      fixedRateAccClosure: {
        enableClosedBtn: false,
        restrictedFixedRateStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
        postingsRestrictions: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF']
      },
      showNoticeCashIsaTransferOutWarning: false,
      showNoticeCloseAccountWarning: false,
      noticeWithdrawalDate: {
        DMY: null,
        YMD: null
      },
      transferOutPlaceNoticeComment: 'ISA Transfer Out',
      showTransferOutSuccessfulDialog: false,
      noticeCashIsa: {
        transferOutOtpRequired: this.$appSettings.defaultConfigurations.noticeCashIsa.transferOut.otpRequired
      },
      isAccountValidModeOfOperation: true,
      accountDetails: {},
      showProductDescription: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableProductDescriptionInBanner,
      productDescription: '',
      maturityDate: '',
      enableAmendMIOnMaturityMonth: this.$appSettings.defaultConfigurations.maturityInstruction.deposits.enableAmendMIOnMaturityMonth,
      accountStatus: '',
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations,
      excludedAccountStatus: this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList,
      excludedJointMOO: this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList,
      t: {
        placeNotice: this.$t('noticeAccountDetails.placeNoticeBtnLabel'),
        transferOutNotice: this.$t('noticeCashIsa.transferOut.button'),
        closeNotice: this.$t('noticeCashIsa.closeAccount.button')
      },
      permissions: [],
      isTransferFundsPermitted: false,
      showSavingsAccountType: {
        transactions: false,
        details: false,
        statements: false,
        paymentStatus: false
      },
      showCurrentAccountType: {
        transactions: false,
        details: false,
        statements: false,
        paymentStatus: false
      },
      showNoticeAccountType: {
        transactions: false,
        details: false,
        statements: false,
        paymentStatus: false
      },
      accountTypesPermissions: {
        SVGS: {
          details: 'SAVING_VIEW_DETAILS',
          transactions: 'SAVING_VIEW_TRANSACTIONS_AND_PAYMENTS',
          statements: 'SAVING_VIEW_AND_DOWNLOAD_STATEMENTS',
          paymentStatus: 'SAVING_VIEW_TRANSACTIONS_AND_PAYMENTS',
          closeAccount: 'SAVING_CLOSE_ACCOUNT'
        },
        CACC: {
          details: 'CURRENT_VIEW_DETAILS',
          transactions: 'CURRENT_VIEW_TRANSACTIONS_AND_PAYMENTS',
          statements: 'CURRENT_VIEW_AND_DOWNLOAD_STATEMENTS',
          paymentStatus: 'CURRENT_VIEW_TRANSACTIONS_AND_PAYMENTS',
          closeAccount: 'CURRENT_CLOSE_ACCOUNT'
        },
        NACC: {
          details: 'NOTICE_VIEW_DETAILS',
          transactions: 'NOTICE_VIEW_TRANSACTIONS_AND_PAYMENTS',
          statements: 'NOTICE_VIEW_AND_DOWNLOAD_STATEMENTS',
          paymentStatus: 'NOTICE_VIEW_TRANSACTIONS_AND_PAYMENTS',
          closeAccount: 'NOTICE_CLOSE_ACCOUNT',
          placeNotice: 'PLACE_NOTICE',
          cancelNotice: 'CANCEL_NOTICE'
        }
      },
      isPlaceNoticePermitted: false,
      isUpdateNominatedAccPermitted: false
    }
  },
  async created () {
    const configParams = this.config.params
    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.isUpdateNominatedAccPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('VIEW_PAYEES') : true
    this.isPlaceNoticePermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('PLACE_NOTICE') : true
    this.fromDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 1)
    )
      .toISOString()
      .substr(0, 10)
    this.postingRestrictionType = this.$route.params.product.postingsRestriction
    this.accountId = configParams.accountId
    this.iban = configParams.iban
    this.accountName = configParams.accountName
    this.availableBalance = this.$route.params.balance
    this.currency = this.$route.params.currency
    this.defaultAccountType = configParams.defaultAccountType
    this.modalConfig.closeAccount.body = ['SVGS', 'CACC'].includes(this.defaultAccountType)
      ? this.$t('closeAccount.casaWarningMessage')
      : this.$t('closeAccount.taxWarningMessage')
    this.sortCode = this.$appSettings.defaultConfigurations.sortCode
    this.setTips(this.defaultAccountType)
    await this.getAccountDetails(this.accountId)
    if (this.defaultAccountType === 'SVGS' || this.defaultAccountType === 'CACC') {
      if (this.enableDebitCard) {
        await this.getDebitCards(this.accountId)
      }
    }
    this.currentTab = configParams.navToTab || 0
    this.isTransferFundsPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('TRANSFER_FUNDS') : true
    Object.keys(this.accountTypesPermissions).forEach((type) => {
      const permissions = this.accountTypesPermissions[type]
      const isCurrentType = this.defaultAccountType === type
      let typeName
      switch (type) {
        case 'SVGS': typeName = 'Savings'
          break
        case 'CACC': typeName = 'Current'
          break
        case 'NACC': typeName = 'Notice'
          break
      }
      this[`show${typeName}AccountType`] = {
        details: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.details) : true,
        transactions: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.transactions) : true,
        statements: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.statements) : true,
        paymentStatus: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.paymentStatus) : true,
        closeAccount: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.closeAccount) : true,
        placeNotice: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.placeNotice) : true,
        cancelNotice: (this.isSmeLogin && this.enableRoleBasedAccess) ? isCurrentType && this.permissions?.includes(permissions?.cancelNotice) : true
      }
    })
    /**
     * if the user clicks on view notice details after successfully placing a notice,
     * route param will have the noticeId, find the id from the notice list and display it.
    **/
    if (configParams.noticeId && this.noticeList.length) {
      await this.displayNoticeDetails(configParams.noticeId)
    }

    event.$on('IS_OTP_VALID', valid => {
      if (valid && this.showOTPScreen) {
        this.showOTPScreen = false
        this.otpModalConfig.enabled = false
        if (this.showNoticeCashIsaTransferOutWarning) {
          this.transferOutNotice()
        } else {
          this.cancelNotice()
        }
      } else {
        this.otpModalConfig.enableSave = true
      }
    })
    event.$on('OTP_RESENT', val => {
      this.otpModalConfig.enableSave = true
    })
  },
  mounted () {
    if (this.allowInactiveAccountTransactionalOperations) {
      this.instCashIsaStatus?.splice(2, 1)
      this.savingsAccClosure?.restrictedCashIsaStatus?.splice(2, 1)
      this.instantCashAccClosure?.restrictedAccStatus?.splice(2, 1)
      this.fixedRateAccClosure?.restrictedFixedRateStatus?.splice(2, 1)
    }
  },
  computed: {
    totalWithdrawalAmount () {
      if (this.noticeList && this.noticeList.length) {
        let res = 0
        let currency = ''
        for (const item of this.noticeList) {
          res += item.totalWithdrawnAmount.amount
          currency = item.totalWithdrawnAmount.currency
        }
        return this.$formatter.currency.format(
          res,
          currency
        )
      }
      return this.noticeAccDetails && this.noticeAccDetails.accruedPenaltyAmount
        ? this.$formatter.currency.format(
          0,
          this.noticeAccDetails.accruedPenaltyAmount.currency
        )
        : this.$formatter.currency.format(
          0,
          this.$appSettings.defaultConfigurations.currencyFormat.currency
        )
    },
    formattedAccountId () {
      return this.$formatter.formatAccount(this.accountId, this.iban)
    },
    disableCancelNotice () {
      const statusToCheck = ['CANCELLED', 'EXPIRED', 'FULLY-UTILIZED', 'OVER-UTILIZED']
      const today = new Date().toISOString().substr(0, 10)

      if (this.selectedNoticeDetails && (statusToCheck.includes(this.selectedNoticeDetails.noticeStatus) ||
      (this.selectedNoticeDetails.noticeStatus === 'ISSUED' && today > this.selectedNoticeDetails.withdrawalDate))) {
        return true
      }
      return false
    },
    totalNoticeIssued () {
      if (!Array.isArray(this.noticeList)) return 0

      return this.noticeList
        .filter(notice => notice.noticeStatus === 'ISSUED')
        .reduce((total, notice) => total + notice.noticeAmount.amount, 0)
    },
    noticeWithdrawableAmount () {
      return this.availableBalance - this.totalNoticeIssued
    },
    showCashIsaTransferOutBtn () {
      return this.isNoticeCashIsaAccount &&
        this.availableBalance > 0 &&
        this.settings.isNoticeTransferOutAllowed &&
        !this.savingsAccClosure.restrictedCashIsaStatus.includes(this.accountStatus) &&
        !this.savingsAccClosure.postingsRestrictions.includes(this.accountDetails.postingsRestriction)
    },
    isInactiveAccountAllowed () {
      return this.accountStatus === 'ACTIVATED' ||
        (this.accountStatus === 'INACTIVE' ? this.allowInactiveAccountTransactionalOperations : false)
    },
    isValidAccountStatus () {
      return this.accountStatus === 'ACTIVATED' ||
        (this.accountStatus === 'INACTIVE' && this.allowInactiveAccountTransactionalOperations)
    },
    showNoticeCloseAccountBtn () {
      return this.settings.isNoticeClosureAllowed &&
        this.availableBalance >= 0 &&
        this.isValidAccountStatus &&
        this.fetchAccTypePermissions('NACC', 'closeAccount')
    },
    withinMaturityDateRange () {
      if (this.enableAmendMIOnMaturityMonth) {
        const depositMaturityDate = new Date(this.maturityDate)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const firstDay = new Date(depositMaturityDate.getFullYear(), depositMaturityDate.getMonth(), 1)
        const beforeMaturity = new Date(depositMaturityDate.getFullYear(), depositMaturityDate.getMonth(), depositMaturityDate.getDate() - 1)
        return today >= firstDay && today <= beforeMaturity
      }
      return true
    },
    showPlaceNotice () {
      return this.availableBalance > 0 && this.isValidAccountStatus && this.isPlaceNoticePermitted
    },
    showLisaTransferInBtn () {
      return this.enableLisaTransferIn &&
      !['CREDIT'].includes(this.accountDetails.postingsRestriction)
    },
    checkCASAAccountListing () {
      // If INACTIVE accounts are included in the CASAccountListing configuration when Inactive accounts are allowed to operate,
      // Place Notice and Cancel Notice won’t be available for
      // Inactive Fixed Rate Cash ISA, Notice Accounts and Notice Cash ISA accounts
      let enable = false
      enable = this.excludedAccountStatus.includes('INACTIVE') &&
      this.allowInactiveAccountTransactionalOperations
        ? !['TXFR', 'TXNA', 'NACC'].includes(this.defaultAccountType)
        : true
      return enable
    },
    settings () {
      const { noticeCashIsa, noticeAccountClosure } = this.$appSettings.defaultConfigurations
      return {
        isNoticeClosureAllowed: this.isNoticeCashIsaAccount ? noticeCashIsa.closeAccount.enabled : noticeAccountClosure.enabled,
        isNoticeTransferOutAllowed: noticeCashIsa.transferOut.enabled
      }
    },
    isCancelNoticeAllowed () {
      const { accountOwnership, modeOfOperation } = this.accountDetails

      return this.enableCancelNotice &&
        (accountOwnership !== 'JOINT' || !this.excludedJointMOO.includes(modeOfOperation)) &&
        (this.accountStatus === 'ACTIVATED' ||
          (this.accountStatus === 'INACTIVE' && this.allowInactiveAccountTransactionalOperations)
        ) && this.fetchAccTypePermissions('NACC', 'cancelNotice')
    },
    placeNoticeDetails () {
      return {
        enabled: this.modalConfig.noticeDetails.enabled,
        title: this.$t('noticeAccountDetails.title'),
        persistent: true,
        btn1Label: this.isCancelNoticeAllowed && this.checkCASAAccountListing
          ? this.$t('noticeAccountDetails.cancelNoticeBtnLabel') : '',
        btn2Label: this.$t('common.back'),
        enableCancel: this.disableCancelNotice,
        width: 600,
        persistOnBtn1: true
      }
    },
    isValidAccountOwnership () {
      const modeOfOperation = this.isNoticeAccount
        ? this.accountDetails.modeOfOperation
        : this.accountDetails.modeOfOperation.code
      const isJointAccountValid = this.accountDetails?.accountOwnership === 'JOINT' &&
        !this.excludedJointMOO.includes(modeOfOperation)
      return this.accountDetails?.accountOwnership === 'SOLE' || isJointAccountValid
    },
    shouldShowNoticeButtons () {
      return (this.isNoticeAccount || this.isNoticeCashIsaAccount) &&
        this.enablePlaceNotice &&
        this.isValidAccountOwnership &&
        !this.isAccountRestricted &&
        !this.isSmeLogin &&
        this.checkCASAAccountListing
    },
    noticeButtons () {
      return [
        {
          show: this.showPlaceNotice,
          click: () => this.placeNotice(this.accountId),
          text: this.t.placeNotice,
          qa: 'casadetails-notice-button-place-notice'
        },
        {
          show: this.showCashIsaTransferOutBtn,
          click: this.handleNoticeCashISATransferOutClick,
          text: this.t.transferOutNotice,
          qa: 'casadetails-notice-button-transfer-out'
        },
        {
          show: this.showNoticeCloseAccountBtn,
          click: this.handleNoticeCloseAccountClick,
          text: this.t.closeNotice,
          qa: 'casadetails-notice-button-close-notice'
        }
      ]
    },
    filteredNoticeButtons () {
      return this.noticeButtons.filter(btn => btn.show)
    },
    headerButtonClass () {
      return 'text-none white--text py-2 px-4'
    },
    headerButtonColProps () {
      return {
        cols: 'auto',
        class: [
          'pa-1',
          this.$vuetify.breakpoint.smAndUp ? 'd-flex justify-end' : 'd-flex justify-start'
        ]
      }
    },
    headerButtonsRowProps () {
      return {
        class: [
          'w-100',
          'd-flex',
          this.$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-wrap',
          'justify-end',
          'gap-1'
        ],
        'no-gutters': true
      }
    }
  },
  methods: {
    async displayNoticeDetails (noticeId) {
      const noticeToView = this.noticeList.find(notice => notice.noticeId === noticeId)

      if (noticeToView) {
        await this.selectedPayment(noticeToView)
      }
    },
    fetchAccTypePermissions (accType, section) {
      let value
      if (this.isSmeLogin && this.enableRoleBasedAccess) {
        switch (accType) {
          case 'SVGS': value = this.showSavingsAccountType[section]
            break
          case 'CACC': value = this.showCurrentAccountType[section]
            break
          case 'NACC': value = this.showNoticeAccountType[section]
            break
          default: value = false
        }
      } else value = true
      return value
    },
    getTabLabel (index) {
      switch (index) {
        case 1: // Transactions
          return this.$t('noticeAccountDetails.tabs.tab1')
        case 2: // Details
          return this.$t('noticeAccountDetails.tabs.tab2')
        case 3: // Statements
          return this.$t('noticeAccountDetails.tabs.tab4')
        case 4: // Payment Status
          return this.$t('noticeAccountDetails.tabs.tab5')
      }
    },
    routeTo (accId) {
      this.$router.push({
        name: 'transferFunds',
        params: {
          accountType: this.defaultAccountType,
          accountNumber: accId,
          balance: this.availableBalance,
          currency: this.currency
        }
      })
    },
    viewDebit (accId) {
      this.$router.push({
        name: 'DebitCard',
        params: {
          accountNumber: accId
        }
      })
    },
    transferIn (accId) {
      this.$router.push({
        name: 'LifetimeIsaTransferIn',
        params: {
          accountType: this.defaultAccountType,
          accountNumber: accId,
          balance: this.availableBalance,
          depositAmt: this.curYrSubAmtUsd,
          currency: this.currency
        }
      })
    },
    checkSavingsAccForClosure (account) {
      if ((account.accountType === 'SVGS') &&
        !this.savingsAccClosure.restrictedCashIsaStatus.includes(account.accountStatus) &&
        !this.savingsAccClosure.postingsRestrictions.includes(account.postingsRestriction) &&
        this.isValidAccountOwnership &&
        this.enableSavingsAccountClosureOption &&
        this.availableBalance >= 0 &&
        !this.isSmeLogin &&
        this.fetchAccTypePermissions('SVGS', 'closeAccount')
      ) {
        this.savingsAccClosure.enableClosedBtn = true
      } else this.savingsAccClosure.enableClosedBtn = false

      if ((account.accountType === 'CACC') &&
        !this.currentAccClosure.restrictedCashIsaStatus.includes(account.accountStatus) &&
        !this.currentAccClosure.postingsRestrictions.includes(account.postingsRestriction) &&
        account.accountOwnership === 'SOLE' &&
        this.enableCurrentAccClosureOption &&
        this.availableBalance >= 0 &&
        !this.isSmeLogin &&
        this.fetchAccTypePermissions('CACC', 'closeAccount')
      ) {
        this.currentAccClosure.enableClosedBtn = true
      } else this.currentAccClosure.enableClosedBtn = false

      if (account.accountType === 'TXFR' &&
        !this.fixedRateAccClosure.restrictedFixedRateStatus.includes(account.accountStatus) &&
        !this.fixedRateAccClosure.postingsRestrictions.includes(account.postingsRestriction) &&
        account.accountOwnership === 'SOLE' &&
        this.enableFixedRateAccClosureOption &&
        this.availableBalance >= 0 &&
        !this.isSmeLogin
      ) {
        this.fixedRateAccClosure.enableClosedBtn = true
      } else this.fixedRateAccClosure.enableClosedBtn = false

      if (account.accountType === 'TXEA' &&
        !this.instantCashAccClosure.restrictedAccStatus.includes(account.accountStatus) &&
        !this.instantCashAccClosure.postingsRestrictions.includes(account.postingsRestriction) &&
        account.accountOwnership === 'SOLE' &&
        this.enableInstCashAccCloseOption &&
        this.availableBalance >= 0 &&
        !this.isSmeLogin
      ) {
        this.instantCashAccClosure.enableClosedBtn = true
      } else this.instantCashAccClosure.enableClosedBtn = false
    },
    amendTaxAccount (accId) {
      this.$router.push({
        name: 'amendTaxSavings',
        params: {
          accountType: this.defaultAccountType,
          accountNumber: accId,
          balance: this.availableBalance,
          currency: this.currency
        }
      })
    },
    closeAccount () {
      this.enableCloseAccount = true
      this.modalConfig.closeAccount.enabled = true
    },
    onCancel () {
      this.enableCloseAccount = false
      this.currentTab = 0
      this.modalConfig.closeAccount.enabled = false
    },
    onContinueClose (accId) {
      this.$router.push({
        name: 'CloseSavingsAccount',
        params: {
          accountType: this.defaultAccountType,
          accountNumber: accId,
          balance: this.availableBalance,
          depositAmt: this.curYrSubAmtUsd,
          currency: this.currency
        }
      })
    },
    getWarningIcon () {
      const warningIcon = this.getSvgIconSrc('WarningIcon')
      return warningIcon
    },
    getNavigationIcon (accType) {
      let returnType
      switch (accType) {
        case 'SVGS':
        case 'NACC':
          returnType = this.getSvgIconSrc('Savings_1')
          break
        case 'CACC':
          returnType = this.getSvgIconSrc('Current2')
          break
        default:
          returnType = this.getSvgIconSrc('Savings_1')
          break
      }
      return returnType
    },
    async getListOfAccountStatements () {
      const details = {
        businessType: 'ACCOUNT',
        businessValue: this.accountId,
        docType: 'CASA',
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      const response = await commonService.getListOfAccDocStatements(details)
      if (response && response.items) {
        this.noStatementsAvail = false
        this.eStatementList = []
        response.items.forEach(item => {
          const fromDate = this.$formatter.formatDate(item.fromDate)
          const toDate = this.$formatter.formatDate(item.toDate)
          this.eStatementList.push({
            data: `${fromDate} to ${toDate}`,
            documentId: item.documentId
          })
        })
      } else {
        this.eStatementList = []
        this.noStatementsAvail = false
        this.noStatementFound = true
      }
    },
    async downloadStatement (type, documentId) {
      const body = {
        businessType: 'ACCOUNT',
        businessValue: this.accountId,
        docType: 'CASA'
      }
      const response = await commonService.downloadStatement(documentId, body)

      if (response && !response.causes) {
        const userLoginId = sessionStorage.getItem('userId')
          ? JSON.parse(sessionStorage.getItem('userId'))
          : JSON.parse(sessionStorage.getItem('username'))
        const fileName = `E-Statement-${userLoginId}.pdf`
        // const blobObject = new Blob([response], { type: 'application/pdf' })
        // const fileURL = window.URL.createObjectURL(blobObject)
        if (type === 'view') {
          this.PDFData = response
          this.viewPDF = true
        } else {
          if (response && !response.causes) { // positive response
            // this.downloadFile(fileURL, fileName)
            var a = document.createElement('a') // Create <a data-qa="casadetails-a-z22nz">
            a.href = response // Image Base64 Goes here
            a.download = fileName
            a.click()
          }
        }
      }
    },
    getAccountTypeLabel (accType) {
      const accountLabels = {
        SVGS: this.$t('accountDetails.savingAccountsLabel'),
        CACC: this.$t('accountDetails.currentAccountsLabel'),
        NACC: this.$t('accountDetails.noticeAccountsLabel'),
        default: this.$t('accountDetails.taxAccountsLabel')
      }

      return accountLabels[accType] || accountLabels.default
    },
    getAccountType (accType) {
      const accountLabels = {
        SVGS: this.$t('accountDetails.savingAccountsLabel'),
        CACC: this.$t('accountDetails.currentAccountsLabel'),
        NACC: this.$t('accountDetails.noticeAccountsLabel'),
        TXNA: this.$t('accountDetails.noticeCashAccountsLabel'),
        TXFR: this.$t('accountDetails.txfrAccountsLabel'),
        TXEA: this.$t('accountDetails.txeaAccountsLabel'),
        TXSV: this.$t('accountDetails.taxAccountsLabel'),
        TXLA: this.$t('accountDetails.txlaAccountsLabel'),
        default: this.$t('accountDetails.savingAccountsLabel')
      }

      return accountLabels[accType] || accountLabels.default
    },
    convertToCapitalisedSentence (sentence) { // fix DOB-1029
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    async getTaxDetails (type, accountNumber) {
      switch (type) {
        case 'current':
          return await commonService.getTaxsavingsDetails(accountNumber)
        case 'previous':
          return await commonService.getPrevYearTaxSavingsDetails(accountNumber)
        default:
          break
      }
    },
    async getAccountDetails (accountNumber) {
      this.loaderEnabled = true
      this.casaDetails = []
      const promises = {
        accountDetails: this.isNoticeAccount ? commonService.noticeAccountDetails(accountNumber) : commonService.getAccountDetails(accountNumber)
      }

      if (this.isNoticeAccount) promises.accountResp = commonService.getAccountDetails(accountNumber)

      if (this.isCashIsaAccount || this.defaultAccountType === 'TXSV') {
        promises.taxDetails = this.getTaxDetails('current', accountNumber)
        promises.prvYearTaxDetails = this.getTaxDetails('previous', accountNumber)
      }

      if (this.isCashIsaAccount) promises.noticeAccountBalances = commonService.getNoticeAccountBalances(this.accountId)

      if (this.defaultAccountType === 'TXSV' || this.defaultAccountType === 'CACC' || this.defaultAccountType === 'SVGS') promises.accountBalances = commonService.getAccountBalances(this.accountId)

      if (this.isNoticeAccount || this.defaultAccountType === 'TXNA') {
        const d = moment()
          .subtract(180, 'days')
          .calendar()
          .split('/')
        const fromDate = `${d[2]}-${d[0]}-${d[1]}`
        const now = moment().format('YYYY-MM-DD')

        promises.noticeAccDetails = commonService.noticeAccDetails(
          accountNumber,
          fromDate,
          now
        )
      }

      if (this.defaultAccountType === 'TXLA') promises.lisaResp = commonService.getLisaTransferIn(accountNumber)

      if (this.config.params?.accountOwnership !== 'SOLE' && (this.defaultAccountType !== 'TXSV' || this.defaultAccountType !== 'TXNA')) promises.casaAccDetails = commonService.noticeAccountDetails(accountNumber)

      if (this.enableAccountsInterestDetails) promises.interestDetails = this.getCASAInterestDetails(this.accountId)
      if (this.enableNominatedAccounts && this.config.params.accountStatus !== 'CLOSED' && this.isUpdateNominatedAccPermitted) promises.nominatedAccDetails = this.getNominatedAccountDetails(this.accountId)
      if (!(this.allowInactiveAccountTransactionalOperations ? false : (this.config.params.accountStatus === 'INACTIVE' || this.config.params.accountStatus === 'STOPPED'))) promises.accStatements = this.getListOfAccountStatements()

      const results = await Promise.all(Object.values(promises))

      const {
        accountDetails: response,
        accountResp,
        taxDetails,
        prvYearTaxDetails,
        noticeAccountBalances,
        accountBalances,
        noticeAccDetails,
        lisaResp,
        casaAccDetails
      } = Object.keys(promises).reduce((acc, key, index) => {
        acc[key] = results[index]
        return acc
      }, {})

      this.accountStatus = this.isNoticeAccount ? accountResp?.accountStatus : response?.accountStatus

      this.productId = response?.productIdentifier || response?.productId
      this.accountDetails = response
      this.checkSavingsAccForClosure(response) // Check if "Close Account" button to be displayed or not
      this.productId = response?.productIdentifier || response?.productId
      const customerId = JSON.parse(sessionStorage.getItem('username'))
      this.getOverallSubScription(customerId)
      if (this.isCashIsaAccount && response && !response.causes) {
        this.curYrSubAmtUsd = taxDetails.subscriptionAmountUsed
        this.isFixedRateCashIsaAccount = response.accountType === 'TXFR'
        this.isInstantCashIsaAccount = response.accountType === 'TXEA'
        this.isNoticeCashIsaAccount = response.accountType === 'TXNA'
        this.isLifetimeIsaAccount = response.accountType === 'TXLA'
      }
      if (this.isFixedRateCashIsaAccount) {
        const resp = await commonService.getCASAProductsList({ currencyType: this.currency, isAccTypeApplicable: 'S' })
        this.casaProducts = resp?.causes || !resp ? [] : resp.items
      }
      const accountStatusAllowed = this.allowInactiveAccountTransactionalOperations
        ? ['ACTIVATED', 'INACTIVE']
        : ['ACTIVATED']
      this.isActive = accountStatusAllowed.includes(response?.accountStatus)

      if (this.isNoticeAccount || this.isNoticeCashIsaAccount) {
        const { accountList } = this.isNoticeAccount
          ? store.getters['userStore/userData'].myAccounts.noticeAccounts
          : store.getters['userStore/userData'].myAccounts.noticeTaxAccounts
        const noticeAccount = accountList.find(account => account.accountId === this.accountId)
        this.clearedBalance = noticeAccount?.clearedBalance ?? 0
      }

      if (this.allowInactiveAccountTransactionalOperations ? false : (response.accountStatus === 'INACTIVE' || response.accountStatus === 'STOPPED')) {
        this.isAccountRestricted = true
      }
      if (this.isInstantCashIsaAccount && this.instCashIsaStatus.includes(response.accountStatus)) {
        this.accCloseRestriction = true
      }
      if (this.postingRestrictionType === 'DEBITCREDIT' || this.postingRestrictionType === 'DEBIT') {
        this.isTransferARIRestricted = true
      }
      if (this.isNoticeAccount || this.isNoticeCashIsaAccount) {
        this.noticeAccountStatus = this.accountStatus
      }
      if (this.defaultAccountType === 'TXSV' || this.defaultAccountType === 'CACC' || this.defaultAccountType === 'SVGS') {
        if (accountBalances && accountBalances.balances) {
          this.clearedBalance = _.filter(accountBalances.balances, { balanceType: 'INTERIMCLEARED' })[0].amount.amount
        }
      }
      if (this.isCashIsaAccount) {
        this.clearedBalance = this.availableBalance ? this.availableBalance : noticeAccountBalances.balanceInformation.clearedBalance
      }
      this.isFetchingData = false

      // Check for Transfer-In details if Lifetime ISA account
      if (this.isLifetimeIsaAccount) {
        this.transferInData = lisaResp
      }
      // Check for Interest Details Flag
      if (this.isNoticeAccount || this.isNoticeCashIsaAccount) {
        this.noticeAccDetails = noticeAccDetails
        this.noticeProductDetails = this.productId ? await commonService.getNoticeProductDetails(this.productId) : {}

        this.noticeList = []
        const groupResult = _.groupBy(this.noticeAccDetails.items, 'noticeId')
        for (const item in groupResult) {
          const noticeDetailsRecent = groupResult[item][0]

          for (let i = 1; i < groupResult[item].length; i++) {
            const currObj = groupResult[item][i]

            for (const key in currObj) {
              if (!(key in noticeDetailsRecent)) {
                noticeDetailsRecent[key] = currObj[key]
              }
            }
          }

          this.noticeList.push(noticeDetailsRecent)
        }
        this.filterableStatuses = this.getFilterableStatuses(this.noticeList)
        this.cancelledNotices = _.filter(this.noticeList, item => { return item.noticeStatus === 'CANCELLED' }).map((value) => {
          if (value.noticeStatus === 'CANCELLED') return value.noticeId
        })
      }

      if (response && !response.causes) {
        const postingsRestrictions = [
          'DEBITCREDIT',
          'ACCSTOPENQ',
          'ACCSTOPENQWITHREF',
          'DEBIT',
          'CREDIT'
        ]
        if (postingsRestrictions.includes(response.postingsRestriction) ||
            postingsRestrictions.includes(response.postingRestriction) ||
            this.isAccountRestricted) {
          const status = this.isAccountRestricted ? 'DEBITCREDIT' : response.postingsRestriction || response.postingRestriction
          this.postingRestrictions.info = this.$t(
            `accountDetails.postingsRestrictions.${status}`
          )
          this.postingRestrictions.color =
            response.accountType === 'SVGS' ? '#009CBD' : '#D84315'
        }

        this.accountCurrency = response && response.currency ? response.currency : ''
        // Adding Tax Savings Account Details
        if (this.defaultAccountType === 'TXSV' || this.isFixedRateCashIsaAccount || this.isNoticeCashIsaAccount || this.isInstantCashIsaAccount || this.isLifetimeIsaAccount) {
          if (taxDetails && !taxDetails.causes) {
            this.disableAmendMIButton = taxDetails?.status === 'MATURED'
            this.taxAccDetails = []
            this.taxAccDetails.push(
              {
                label: 'isaAllowance',
                value: taxDetails.subscriptionAmount
                  ? this.$formatter.currency.format(taxDetails.subscriptionAmount)
                  : this.$formatter.currency.format(0)
              },
              {
                label: 'allowanceUsed',
                value: taxDetails.subscriptionAmountUsed
                  ? this.$formatter.currency.format(taxDetails.subscriptionAmountUsed)
                  : this.$formatter.currency.format(0)
              },
              {
                label: 'allowanceRemaining',
                value: (taxDetails.subscriptionAmount && taxDetails.subscriptionAmountUsed)
                  ? this.$formatter.currency.format(taxDetails.subscriptionAmount - taxDetails.subscriptionAmountUsed)
                  : this.$formatter.currency.format(0)
              }
            )
            if (this.isFixedRateCashIsaAccount) {
              this.maturityDate = taxDetails.fixedRateMaturityDate
              this.casaDetails.push(
                {
                  label: 'startDate',
                  value: taxDetails.dateOfFirstDeposit ? this.$formatter.formatDate(taxDetails.dateOfFirstDeposit) : '-'
                },
                {
                  label: 'depositCount',
                  value: taxDetails.noOfDeposits ? taxDetails.noOfDeposits : '-'
                }
              )
              this.taxAccMaturityDetails.push(
                {
                  label: 'maturityDate',
                  value: taxDetails.fixedRateMaturityDate ? this.$formatter.formatDate(taxDetails.fixedRateMaturityDate) : '-'
                },
                {
                  label: 'maturityInstruction',
                  value: this.getFixedRateMaturityInstructionText(taxDetails)
                }
              )
              if (taxDetails.fixedRateTaxSavingsDetails?.principalPayAwayAccounts?.[0].payawayAccountId) {
                this.taxAccMaturityDetails.push(
                  {
                    label: 'maturityAccount',
                    value: taxDetails.fixedRateTaxSavingsDetails.principalPayAwayAccounts[0].payawayAccountId
                  }
                )
              }
              if (taxDetails.switchOverProductID) {
                const productDescription = this.casaProducts.find(i => i.productId === taxDetails.switchOverProductID)?.productDescription || ''
                this.taxAccMaturityDetails.push(
                  {
                    label: 'rolloverSubProduct',
                    value: `${taxDetails.switchOverProductID} - ${productDescription}`
                  }
                )
              }
              if (taxDetails.fixedRateTaxSavingsDetails?.rolloverAmount?.amount) {
                this.taxAccMaturityDetails.push(
                  {
                    label: 'rolloverAmount',
                    value: this.$formatter.currency.format(taxDetails.fixedRateTaxSavingsDetails.rolloverAmount.amount, taxDetails.fixedRateTaxSavingsDetails.rolloverAmount.currency)
                  }
                )
              }
              if (taxDetails.fixedRateTaxSavingsDetails?.rolloverPercent && taxDetails.fixedRateTaxSavingsDetails?.principalPayAwayAccounts?.length) {
                this.taxAccMaturityDetails.push(
                  {
                    label: 'rolloverPercent',
                    value: `${taxDetails.fixedRateTaxSavingsDetails.rolloverPercent} %`
                  }
                )
              }
            }
          }
          if (this.isNoticeCashIsaAccount) {
            this.taxAccDetails.push(
              {
                label: 'previousYearLabel',
                value: prvYearTaxDetails && !prvYearTaxDetails.causes ? this.$formatter.currency.format(prvYearTaxDetails?.subscriptionAmountUsed) : this.$formatter.currency.format(0)
              }
            )
          } else {
            this.taxAccDetailsPreviousYear.push(
              {
                label: 'subscriptionAmtUsed',
                value: prvYearTaxDetails?.subscriptionAmountUsed && !prvYearTaxDetails.causes ? this.$formatter.currency.format(prvYearTaxDetails?.subscriptionAmountUsed) : this.$formatter.currency.format(0)
              }
            )
          }
        }
        if (!this.isNoticeAccount) {
          if (response.accountDescription) {
            this.productDescription = response.accountDescription
            this.casaDetails.push({
              label: this.isFixedRateCashIsaAccount ? 'product' : 'accountDescription',
              value: response.accountDescription
            })
          }
          
          //customization
          if(this.isShowAccountType){
            this.casaDetails.push(
            {
              label: 'accountType',
              value: this.getAccountType(response.accountType)?.replace('Account', '')
            },
          )
          }
          this.casaDetails.push(
            {
              label: 'accountName',
              value: response.accountName,
              attachEditIcon:
                !['STOPPED', 'CLOSED'].includes(response.accountStatus) ? {
                  icon: 'edit'
                } : ''
            },
            {
              label: 'accountStatus',
              value: this.$t(`systemEnums.casa.${response.accountStatus}`)
            }
          )
          if (!this.isNoticeCashIsaAccount) {
            this.casaDetails.push(
              {
                label: 'currency',
                value: response.currency
              },
              {
                label: 'accountOwnership',
                value:
                  response.accountOwnership === 'SOLE'
                    ? this.$t('common.no')
                    : this.$t('common.yes')
              }
            )
          }

          if (!this.isNoticeCashIsaAccount && response.accountOwnership !== 'SOLE' && this.defaultAccountType !== 'TXSV') {
            this.casaAccountDetails = casaAccDetails
            this.isAccountValidModeOfOperation =
              !(this.casaAccountDetails.accountOwnership === 'JOINT' && this.excludedJointMOO.includes(this.casaAccountDetails.modeOfOperation))
            this.casaDetails.push({
              label: 'modeOfOperation',
              value: this.casaAccountDetails.modeOfOperation
                ? this.$t(`systemEnums.modeOfOperations.${this.casaAccountDetails.modeOfOperation}`)
                : ''
            })
          }
          //customization
          if (!this.isFixedRateCashIsaAccount && !this.isNoticeCashIsaAccount&&this.isShowSortcode) {
            this.casaDetails.push(
              {
                label: 'sortCode',
                value: this.sortCode
              }
            )
          }
        }
        if (!this.sameTypeTaxAcc.includes(this.defaultAccountType) && !this.isFixedRateCashIsaAccount && !this.isNoticeCashIsaAccount) {
          if (response && this.productId) {
            await this.getProductsMinimumBalance(this.productId)
          }
        }
        if (this.defaultAccountType === 'CACC' || this.defaultAccountType === 'SVGS') {
          this.casaDetails.push(
            {
              label: 'clearedBalance',
              value: this.clearedBalance
                ? this.$formatter.currency.format(this.clearedBalance, response.currency) : this.$t('myAccounts.balanceInquiryRestricted')
            }
          )
        }
        if (this.sameTypeTaxAcc.includes(this.defaultAccountType) || this.isNoticeCashIsaAccount) {
          // if TXSV push Cleared Balance
          this.casaDetails.push(
            {
              label: 'clearedBalance',
              value: this.$formatter.currency.format(this.clearedBalance, response.currency)
            }
          )
          this.casaDetails = _.filter(this.casaDetails, item => { return item.label !== 'accountOwnership' })
        }
        // Filter out Joint Account label, value for TXNA product
        if (this.isFixedRateCashIsaAccount) {
          this.casaDetails = _.filter(this.casaDetails, item => { return item.label !== 'accountOwnership' })
        }
        if (this.isNoticeAccount || this.isNoticeCashIsaAccount) {
          if (!this.isNoticeCashIsaAccount) {
            if (response.productDescription) {
              this.productDescription = response.productDescription
              this.casaDetails.push({
                label: 'accountDescription',
                value: response.productDescription
              })
            }
            this.casaDetails.push(
              {
                label: 'accountType',
                value: this.$t('common.noticeLabel')
              },
              {
                label: 'accountName',
                value: response.accountName,
                attachEditIcon:
                  !['STOPPED', 'CLOSED'].includes(response.accountStatus) ? {
                    icon: 'edit'
                  } : ''
              },
              {
                label: 'accountStatus',
                value: this.$t(`systemEnums.casa.${this.noticeAccountStatus}`)
              },
              {
                label: 'jointAccount',
                value:
                response.accountOwnership === 'SOLE'
                  ? this.$t('common.no')
                  : this.$t('common.yes')
              },
              {
                label: 'sortCode',
                value: this.sortCode
              },
              {
                label: 'clearedBalance',
                value: this.$formatter.currency.format(this.clearedBalance, this.currency)
              }
            )
          }
          if (response.accountOwnership !== 'SOLE' && this.defaultAccountType !== 'TXSV') {
            this.casaAccountDetails = casaAccDetails
            this.isAccountValidModeOfOperation =
              !(this.casaAccountDetails.accountOwnership === 'JOINT' && this.excludedJointMOO.includes(this.casaAccountDetails.modeOfOperation))
            this.casaDetails.push({
              label: 'modeOfOperation',
              value: this.$t(`systemEnums.modeOfOperations.${this.casaAccountDetails.modeOfOperation}`)
            })
          }
          // Adding Notice Account Details
          if (this.noticeAccDetails?.noticePeriod) {
            this.getNoticeDetails()
          }
        }
        const exclusionLists = [
          ...this.$appSettings.uiFieldsDisplayConfigurations.casaEnquiry.exclusionList,
          ...(this.isNoticeAccount ? this.$appSettings.uiFieldsDisplayConfigurations.hideNoticeDetailsList.exclusionList : []),
          ...(this.defaultAccountType === 'TXSV' ? this.$appSettings.uiFieldsDisplayConfigurations.hideTaxAccountDetailsList.exclusionList : [])
        ]
        this.casaDetails = this.casaDetails.filter(item => !exclusionLists.includes(item.label))
        this.noticeDetails = this.noticeDetails.filter(item => !exclusionLists.includes(item.label))
        this.getBalInfo(this.casaDetails)
      }
      this.loaderEnabled = false
    },
    onIconClick (eventObj) {
      const { label, value } = eventObj
      if (label === 'nominatedAccount') {
        this.nominatedAccount = value
        this.$router.push({
          name: 'UpdateNominatedAccount',
          params: { accountId: this.accountId, accDetails: this.casaDetails, accountCurrency: this.accountCurrency, accountBalance: this.availableBalance }
        })
      }
    },
    async getNominatedAccountDetails (accountNumber) {
      if (!['CACC', 'NACC', 'TXLA'].includes(this.defaultAccountType)) {
        const res = await commonService.getNominatedAccount(accountNumber)
        this.casaDetails.push({
          label: 'nominatedAccount',
          value: (res && res.allowPayawayToOtherBank) ? res.payawayAccountId : '',
          attachIcon: {
            icon: 'edit'
          }
        })
      }
    },
    getBalInfo (casaDetails) {
      let status = ''
      if (
        this.availableBalance !== undefined &&
        this.availableBalance.toString().trim().length > 0
      ) {
        if (isNaN(this.availableBalance)) {
          return this.availableBalance
        } else {
          return this.$formatter.currency.format(
            this.availableBalance,
            this.currency
          )
        }
      } else {
        casaDetails.forEach(item => {
          if (item.label === 'accountStatus') {
            status = item.value
          }
        })
        if (!this.availableBalance && status === 'Active') {
          return this.$t('myAccounts.balanceInquiryRestricted')
        } else {
          return this.$t('myAccounts.notAvailableLabel')
        }
      }
    },
    transactionDetails (item) {
      this.transactionList = true
    },
    setTips (accountType) {
      if (accountType === 'SVGS') {
        this.tips = this.$appSettings.screenTips.savings
      } else if (accountType === 'CACC') {
        this.tips = this.$appSettings.screenTips.current
      }
    },
    getNoticeAccStatus (status) {
      return this.$t(`systemEnums.noticeAccountsStatus.${status}`)
    },
    getStatusColor (status) {
      switch (status) {
        case 'ISSUED':
        case 'FULLY-UTILIZED':
          return 'green'
        case 'EXPIRED':
        case 'CANCELLED':
          return 'errorColor'
        case 'UNDER-UTILIZED':
        case 'OVER-UTILIZED':
          return '#EB8412'
        default:
          return 'green'
      }
    },
    async selectedPayment (item, index) {
      this.selectedNoticeDetails = item
      this.placedNoticeDetails = []

      const push = (label, value) => this.placedNoticeDetails.push({ label, value })

      push('amount', this.$formatter.currency.format(item.noticeAmount.amount, item.noticeAmount.currency))
      push('status', this.$t(`systemEnums.noticeAccountsStatus.${item.noticeStatus}`))
      push('issueDate', this.$formatter.formatDate(item.noticeIssueDate))
      push('withdrawalDate', this.$formatter.formatDate(item.withdrawalDate))

      if (item?.payAwayaccount) {
        push('withdrawalAccount', item.payAwayaccount)
      }
      if (this.noticeAccDetails?.accruedPenaltyAmount?.amount > 0) {
        push('penalty', this.$formatter.currency.format(this.noticeAccDetails.accruedPenaltyAmount.amount, this.noticeAccDetails.accruedPenaltyAmount.currency))
      }

      push('expireDate', this.$formatter.formatDate(item.noticeExpiryDate))

      if (item.reasonForWithdrawal) {
        const response = await commonService.getGenericCodes({ codeReferences: [{ reference: 'REASON_FOR_WITHDRAWAL' }] })
        const reasonsListArray = response?.aggregateCodes?.[0]?.codes ?? []
        const withdrawalReason = reasonsListArray.filter(reason => reason.codeReference === item.reasonForWithdrawal)
        push(item.isISAOrNoticeClosure ? 'closureReason' : 'withdrawalReason', withdrawalReason?.[0]?.codeDescription)
      }
      if (item?.comments && !item?.reasonForWithdrawal) {
        push('comments', item.comments)
      }
      if (item?.isISAOrNoticeClosure) {
        push('closeAccount', this.$t('common.yes'))
      }
      if (item?.isISATransferOut) {
        push('transferOut', this.$t('common.yes'))
      }
      this.modalConfig.noticeDetails.enabled = true
    },
    getFilterableStatuses (notices) {
      const filterableStatuses = []
      filterableStatuses.push('ISSUED')
      if (!notices) { return filterableStatuses }
      notices.forEach(notice => {
        if (filterableStatuses.includes(notice.noticeStatus)) return
        filterableStatuses.push(notice.noticeStatus)
      })
      return filterableStatuses
    },
    filterIssuedNotices () {
      if (this.noticeList && this.noticeList.length) {
        const noticeArr = this.noticeList.filter(notice => notice.noticeStatus === this.selectedFilterStatus)
        let ordered
        switch (this.selectedFilterStatus) {
          case 'FULLY-UTILIZED' :
          case 'UNDER-UTILIZED' :
          case 'OVER-UTILIZED' :
            ordered = _.orderBy(noticeArr, ['withdrawalDate'], ['desc'])
            break
          case 'EXPIRED' :
            ordered = _.orderBy(noticeArr, ['noticeExpiryDate'], ['desc'])
            break
          default :
            ordered = _.orderBy(noticeArr, ['noticeIssueDate'], ['desc'])
            break
        }

        return ordered
      }
    },
    onOtpModalClose () {
      this.otpModalConfig.enabled = false
      this.showOTPScreen = false
    },
    placeNotice (account) {
      this.$store.dispatch('profileStore/setProfileData', {
        accountToPlaceNotice: {
          accountID: account,
          postingRestrictionType: this.postingRestrictionType,
          balance: this.availableBalance,
          currency: this.currency,
          noticePeriod: this.noticeAccDetails?.noticePeriod || { value: this.noticeProductDetails?.noticePeriod, unit: this.noticeProductDetails?.noticePeriodUnit },
          isCashIsaAccount: this.isCashIsaAccount,
          availableBalance: this.$formatter.currency.format(
            this.availableBalance,
            this.currency
          )
        }
      })
      this.$router.push({ name: 'PlaceNotice' })
    },
    cancelNoticeHandler () {
      if (this.enableOTPToCancelNotice) {
        this.modalConfig.noticeDetails.enabled = true
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
      } else {
        this.cancelNotice()
      }
    },
    async cancelNotice () {
      this.modalConfig.noticeDetails.enabled = false
      this.loaderEnabled = true
      const payload = {
        comments: 'Cancelling Notice'
      }
      const resp = await commonService.cancelNotice(
        this.selectedNoticeDetails.noticeId,
        payload
      )
      if (resp && resp.accountId) {
        await this.getAccountDetails(this.accountId)
        this.showConfirmationModal = true
        this.showPlacedNoticeDetails = false
      }
      this.loaderEnabled = false
    },
    async viewCancelledNoticeDetails () {
      this.showConfirmationModal = false
      this.selectedFilterStatus = 'CANCELLED'
      await this.displayNoticeDetails(this.selectedNoticeDetails.noticeId)
    },
    getNoticeAccDate (account) {
      let noticeDate = account.noticeIssueDate
      switch (account.noticeStatus) {
        case 'FULLY-UTILIZED' :
        case 'UNDER-UTILIZED' :
        case 'OVER-UTILIZED' :
          noticeDate = account.withdrawalDate
          break
        case 'EXPIRED' :
          noticeDate = account.noticeExpiryDate
          break
        case 'CANCELLED' :
          noticeDate = account.noticeCancelDate
          break
        default : break
      }
      return this.$formatter.formatDate(noticeDate)
    },
    async getCASAInterestDetails (accountId) {
      const response = await commonService.getCASAInterestDetails(accountId)
      this.creditInterestDetails = []
      this.debitInterestDetails = []
      this.noticeCashIsaCreditInterestDetails = []

      if (response.creditInterestDetails) {
        const {
          effInterestRate, nextInterestApplicationDate, interestApplicationFrequency
        } = response.creditInterestDetails

        this.creditInterestDetails.push(
          {
            label: 'interestRate',
            value: `${effInterestRate} %`
          },
          {
            label: this.isFixedRateCashIsaAccount ? 'nextDueDate' : 'nextInterestDue',
            value: this.$formatter.formatDate(nextInterestApplicationDate)
          },
          {
            label: this.isFixedRateCashIsaAccount ? 'paymentMethod' : 'interestPaymentMethod',
            value: response.creditInterestDetails.creditInterestMethod
          },
          {
            label: this.isFixedRateCashIsaAccount ? 'paymentFrequency' : 'interestPaymentFrequency',
            value: interestApplicationFrequency
          }
        )

        this.noticeCashIsaCreditInterestDetails.push(
          { label: 'interestRate', value: `${effInterestRate} %` },
          { label: 'nextInterestDue', value: this.$formatter.formatDate(nextInterestApplicationDate) },
          { label: 'interestPaymentFrequency', value: interestApplicationFrequency }
        )
      }
      if (response.debitInterestDetails) {
        this.debitInterestDetails.push(
          {
            label: 'interestRate',
            value: `${response.debitInterestDetails.effInterestRate} %`
          },
          {
            label: 'nextInterestDue',
            value: this.$formatter.formatDate(response.debitInterestDetails.nextInterestApplicationDate)
          },
          {
            label: 'interestPaymentMethod',
            value: response.debitInterestDetails.debitInterestMethod
          },
          {
            label: 'interestPaymentFrequency',
            value: response.debitInterestDetails.interestApplicationFrequency
          }
        )
      }
    },
    async getProductsMinimumBalance (productId) {
      const response = await commonService.getCASAProductSummary(productId)
      if (response && response.minimumAccountOpeningBalance) {
        this.casaDetails.push(
          {
            label: 'minBalance',
            value: this.$formatter.currency.format(
              response.minimumAccountOpeningBalance.value,
              response.minimumAccountOpeningBalance.currency
            )
          }
        )
      }
    },
    async getDebitCards (accountId) {
      try {
        const response = await commonService.getListOfDebitCards(accountId)
        if (response && response.items) {
          this.debitCardsFound = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleNoticeCashISATransferOutClick () {
      this.showNoticeCashIsaTransferOutWarning = true
      this.calcNoticeWithdrawalDate()
    },
    handleNoticeCloseAccountClick () {
      this.showNoticeCloseAccountWarning = true
      this.calcNoticeWithdrawalDate()
    },
    handleNoticeCashISATransferOutContinue () {
      if (this.noticeCashIsa.transferOutOtpRequired) {
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
        return
      }
      this.transferOutNotice()
    },
    handleNoticeCashIsaCloseAccountContinue () {
      const params = this.$route.params
      params.withdrawalDate = this.noticeWithdrawalDate.YMD
      params.withdrawalDateDisplay = this.noticeWithdrawalDate.DMY
      params.withdrawalAvailableAmount = this.noticeWithdrawableAmount
      params.availableBalance = this.availableBalance
      params.isNoticeAccount = this.isNoticeAccount
      params.accountType = this.config.params.defaultAccountType
      this.$router.push({
        name: 'NoticeCashIsaCloseAccount',
        params: params
      })
    },
    handleNoticeCashIsaViewNoticeClick () {
      this.showTransferOutSuccessfulDialog = false
      this.currentTab = 2
    },
    handleNoticeCashIsaGotoDashboardClick () {
      this.$router.push('/home')
    },
    async transferOutNotice () {
      const payload = {
        noticeAmount: {
          amount: parseFloat(this.noticeWithdrawableAmount),
          currency: this.currency
        },
        withdrawalDate: this.noticeWithdrawalDate.YMD,
        comments: this.transferOutPlaceNoticeComment,
        isISATransferOut: true
      }
      const resp = await commonService.placeNotice(
        this.accountId,
        payload
      )
      if (resp && resp.noticeId) {
        this.getAccountDetails(this.accountId)
        this.showNoticeCashIsaTransferOutWarning = false
        this.showTransferOutSuccessfulDialog = true
      }
    },
    addDays (days) {
      return {
        DMY: moment().add(days, 'days').format('D-MMM-YYYY'),
        YMD: moment().add(days, 'days').format('YYYY-MM-DD')
      }
    },
    calcNoticeWithdrawalDate () {
      const account = this.noticeAccDetails
      const product = this.noticeProductDetails
      this.noticeWithdrawalDate = this.calcDate(
        account?.noticePeriod?.value ?? product.noticePeriod,
        account?.noticePeriod?.unit ?? product.noticePeriodUnit
      )
    },
    calcDate (value, unit) {
      const map = {
        DAYS: 'days',
        MONTHS: 'months',
        YEARS: 'years'
      }
      const date = moment().add(value, map[unit])
      return {
        DMY: date.format('D-MMM-YYYY'),
        YMD: date.format('YYYY-MM-DD')
      }
    },
    viewNoticeDetails () {
      this.showTransferOutSuccessfulDialog = false
    },
    getNoticeDetails () {
      const { formatPeriod, noticeAccDetails: d } = this
      this.noticeDetails = []
      this.noticeDetails.push(
        {
          label: 'noticePeriod',
          value: formatPeriod(d.noticePeriod.value, d.noticePeriod.unit)
        },
        {
          label: 'withdrawalFreezePeriod',
          value: formatPeriod(d.withdrawalFreezePeriod.value, d.withdrawalFreezePeriod.unit)
        },
        {
          label: 'noticeFreeWithdrawalAmt',
          value: this.$formatter.currency.format(d.noticeFreeWithdrawalAmt.amount, d.noticeFreeWithdrawalAmt.currency)
        },
        {
          label: 'noticeGracePeriod',
          value: formatPeriod(d.gracePeriod.value, d.gracePeriod.unit)
        }
      )
      if (this.isNoticeAccount) {
        this.noticeDetails.push({ label: 'totalWithdrawalAmt', value: this.totalWithdrawalAmount })
      }
      if (d?.accruedPenaltyAmount && this.isAccruedPenaltyEnabled) {
        this.noticeDetails.push({
          label: 'penalty',
          value: this.$formatter.currency.format(d.accruedPenaltyAmount.amount, d.accruedPenaltyAmount.currency)
        })
      }
    },
    formatPeriod (period, unit) {
      return _.startCase(_.lowerCase(`${period} ${unit}`))
    },
    getTabLabels () {
      return this.isNoticeAccount || this.isNoticeCashIsaAccount ? this.noticeAccTabLabels
        : this.isLifetimeIsaAccount ? this.lisaAccTabLabels
          : Array.from({ length: 4 }, (_, n) => this.getTabLabel(n + 1))
    },
    async getOverallSubScription (customerId) {
      const response = await commonService.getOverallSubscrptionCashIsa(customerId)
      if (response && response.taxSavingsAccountDetails) {
        const details = response.taxSavingsAccountDetails
        const matchingAccount = details.find(account => account.accountId === this.accountId)
        if (matchingAccount) {
          const voidAmount = matchingAccount.voidAmount
          this.voidedAmount = this.$formatter.currency.format(voidAmount.amount, voidAmount.currency)

          this.taxAccDetails.push({
            label: 'voidedAmountLabel',
            value: this.voidedAmount
          })
        }
      }
    },
    getFixedRateMaturityInstructionText (taxDetails) {
      const { fixedRateMaturityInstructions: mi, fixedRateTaxSavingsDetails: sd } = taxDetails
      const text = (v) => this.$t(`systemEnums.maturityInstructions.FIXED-RATE-CASHISA-MI.${v}`)
      if (mi === 'PAYAWAY-BOTH' && sd.principalPayAwayAccounts?.[0]) {
        return text(sd.principalPayAwayAccounts[0].otherBankAccount ? 'PAYAWAY-BOTH-EXTERNAL' : 'PAYAWAY-BOTH-INTERNAL')
      }
      if (mi === 'FIXED-RATE-TAX-SAVINGS' && sd.principalPayAwayAccounts?.[0]) {
        return text(sd.principalPayAwayAccounts[0].otherBankAccount ? 'FIXED-RATE-TAX-SAVINGS-REINVEST-EXTERNAL' : 'FIXED-RATE-TAX-SAVINGS-REINVEST-INTERNAL')
      }
      return text(mi)
    }
  },
  watch: {
    showOTPScreen () {
      if (this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
<style scoped>
.v-tooltip__content_amend {
    max-width: 400px;
    text-align: center;
  }
</style>
